module.exports = __webpack_public_path__ + "static/media/soviet_artillery_120.4be90d61.png";